export default "__VITE_ASSET__lgQLnPVJ__"